<template>
  <div>
    <CCard>
      <loader v-if="loading" />
      <CCardHeader>
        <CIcon name="cil-grid" />Product Catalog
        <div class="card-header-actions">
          <CLink href="#" class="card-header-action btn-setting">
            <a @click="addCatalog">
              <CIcon name="cil-plus" />
            </a>
          </CLink>
        </div>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol col="4">
            <div class="form-group">
              <brand-selector v-model="filter.brand" @input="changeBrand" />
            </div>
          </CCol>
          <CCol col="4">
            <div class="form-group">
              <category-selector
                v-model="filter.category"
                @input="changeCategory"
              />
            </div>
          </CCol>
          <CCol col="4">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                placeholder="Ketikkan keyword"
                v-model="filter.keyword"
                @keyup="changeKeyword"
              />
            </div>
          </CCol>
        </CRow>
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>No</th>
              <th>Pic</th>
              <th>Name</th>
              <th>Brand</th>
              <th>Variants</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data && data.data && data.data.length < 1">
              <td colspan="7" align="center">Data tidak ditemukan</td>
            </tr>
            <tr v-for="(d, k) in data.data" :key="k">
              <td>
                <table-number
                  :size="data.paginate.size"
                  :page="data.paginate.page"
                  :index="k"
                />
              </td>
              <td><img :src="d.avatar_url" style="width: 50px" /></td>
              <td>
                <strong>{{ d.name }}</strong
                ><br />
                <span>{{ d.description }}</span>
              </td>
              <td>
                {{ d.brand.name }}<br />
                <CBadge color="warning">{{ d.category.name }}</CBadge>
              </td>
              <td>
                <CBadge
                  color="success margin-span"
                  v-for="(da, ky) in d.variants"
                  :key="ky"
                  >{{ da.label }}</CBadge
                >
              </td>
              <td>
                <CBadge color="danger" v-show="d.deleted_at">Deleted</CBadge>
                <CBadge color="success" v-show="!d.deleted_at">Active</CBadge>
              </td>
              <td class="action">
                <btn-edit @click="doEdit(d.id)" />
                <btn-delete @click="doDelete(d.id)" v-show="!d.deleted_at" />
              </td>
            </tr>
          </tbody>
        </table>
      </CCardBody>
      <CCardFooter>
        <content-pagination
          :page="paginate.page"
          :total="paginate.total"
          :size="paginate.size"
          @input="changePage"
        />
      </CCardFooter>
    </CCard>
  </div>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import { showErrorMessage, serialize } from "../../lib/helpers";
import BtnEdit from "../../components/BtnEdit";
import BtnDelete from "../../components/BtnDelete";
import ContentPagination from "../../components/ContentPagination";
import TableNumber from "../../components/TableNumber";
import Loader from "../../components/Loader";
import BrandSelector from "../../components/BrandSelector.vue";
import CategorySelector from "../../components/CategorySelector.vue";
export default {
  components: {
    BtnEdit,
    BtnDelete,
    ContentPagination,
    TableNumber,
    Loader,
    BrandSelector,
    CategorySelector,
  },
  data() {
    return {
      filter: {
        brand: null,
        category: null,
        keyword: "",
      },
      data: {},
      paginate: {},
      loading: false,
      query: {
        brand: "",
        category: "",
        q: "",
        page: 1,
      },
    };
  },
  created() {
    this.query = this.$route.query;
    if (query.category) {
      this.query.category = query.category;
      this.getCategory(query.category);
    }
    if (query.q) {
      this.filter.keyword = query.q;
    }
    if (query.brand) {
      this.query.brand = query.brand;
      this.getBrand(query.brand);
    }
    setTimeout(this.getList, 1000);
  },
  methods: {
    changePage(page) {
      this.changeRoute("page", page);
      this.getList();
    },
    getList() {
      this.loading = true;
      const q = serialize(this.query);
      console.log(this.query);
      HTTPAUTH.get(`/api/admin/product-master?status=1&size=10&${q}`)
        .then((res) => {
          this.data = res.data;
          this.paginate = this.data.paginate;
          this.loading = false;
        })
        .catch((eres) => {
          this.loading = false;
        });
    },
    addCatalog() {
      this.$router.push({ path: "/product/catalog/new" }).catch((eres) => {});
    },
    doEdit(slug) {
      this.$router
        .push({ path: "/product/catalog/" + slug })
        .catch((eres) => {});
    },
    doDelete(id) {
      HTTPAUTH.delete(`/api/admin/product-master/${id}`)
        .then((res) => {
          this.getList();
        })
        .catch((eres) => {
          console.log(showErrorMessage(eres));
        });
    },
    changeBrand(b) {
      if (!b) {
        this.changeRoute("brand", "");
        this.filter.brand = null;
      } else {
        this.changeRoute("brand", b.id);
        this.filter.brand = b;
      }
      this.getList();
    },
    changeCategory(c) {
      if (!c) {
        this.changeRoute("category", "");
        this.filter.category = null;
      } else {
        this.changeRoute("category", c.id);
        this.filter.category = c;
      }
      this.getList();
    },
    changeKeyword(evt) {
      if (evt.keyCode == 13) {
        this.changeRoute("q", this.filter.keyword);
        this.getList();
      }
    },
    getBrand(id) {
      HTTPAUTH.get("/api/admin/brand/" + id).then((res) => {
        this.filter.brand = res.data.data;
      });
      this.getList();
    },
    getCategory(id) {
      HTTPAUTH.get("/api/admin/product-category/" + id).then((res) => {
        this.filter.category = res.data.data;
      });
      this.getList();
    },
    changeRoute(key, value) {
      this.query = this.$route.query;
      this.query[key] = value;
      console.log(key, value, this.query);
      this.$router.push({ query: this.query }).catch((eres) => {});
    },
  },
};
</script>